export default __webpack_public_path__ + "static/media/36I-102737_-43613_0.f0376fc6.jpg";